import { DEFAULT_LABELKEY } from '../constants';
export default function getStringLabelKey(labelKey) {
  return typeof labelKey === 'string' ? labelKey : DEFAULT_LABELKEY;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap-typeahead/es/utils/getStringLabelKey.js
// module id = 427
// module chunks = 31